export { PinkButton } from './PinkButton';
